import React from "react";
import { useTranslation } from "react-i18next";

export default function Frm(): JSX.Element {
    const { t } = useTranslation("assessment");
    return (
        <>
            <h3>{t("frm.title") as string}</h3>
            <p>{t("frm.paragraph-1") as string}</p>
            <p>{t("frm.paragraph-2") as string}</p>
            <p>{t("frm.paragraph-3-1") as string}<a href={t("frm.hyperlink-1") as string} target='_blank' rel="noopener noreferrer">{t("frm.hyperlink-text-1") as string}</a>{t("frm.paragraph-3-2") as string}</p>
            <p>{t("frm.list-title") as string}</p>
            <ul>
                <li>{t("frm.list.point-1") as string}</li>
                <li>{t("frm.list.point-2") as string}</li>
                <li>{t("frm.list.point-3") as string}</li>
                <li>{t("frm.list.point-4") as string}</li>
                <li>{t("frm.list.point-5") as string}</li>
            </ul>
            <p>{t("frm.paragraph-4") as string}</p>
            <p>{t("frm.paragraph-5") as string}<a className="bolder-text" href={t("frm.hyperlink-2") as string} target='_blank' rel="noopener noreferrer">{t("frm.hyperlink-text-2") as string}</a>.</p>
        </>
    );
}